import { ComponentType, FunctionComponent } from 'react'
import { Props } from './tpaWidgetNative'
import { OOISsrManager } from '../types'

const getFactory = (): (({
	ReactComponent,
	ooiSsrManager,
}: {
	ReactComponent?: ComponentType<any>
	ooiSsrManager?: OOISsrManager
}) => FunctionComponent<Props>) => {
	if (process.env.browser) {
		return require('./tpaWidgetNativeClient').createTpaWidgetNative
	} else {
		return require('./tpaWidgetNativeSSR').createTpaWidgetNative
	}
}

export const createTpaWidgetNative = getFactory()
